import { IProjectAttribute } from 'src/models';
import * as _ from 'lodash';

export default {
    // patch: santd Select 组件显示下拉列表
    // - 打开时，滚动到当前值选项
    // - 按上下箭头切换 item 时，超出 menu 屏的 item，滚动到屏内
    patchOnDropdownVisibleChange(
        open: boolean,
        sanComponent: any,  // san组件的根元素 this.el
        value: IProjectAttribute | IProjectAttribute[],   // 下拉列表的当前值
        options: IProjectAttribute[]    // 下拉列表选项
    ) {
        if (!open) {
            $(sanComponent).off('keydown');
            return;
        }

        // 打开时，滚动到当前值选项
        setTimeout(() => {
            const dropdownMenuEle = $(sanComponent).find('.santd-select-dropdown-menu')[0];
            const dropdownItemEle = $(sanComponent).find('.santd-select-dropdown-menu-item')[0];
            if (dropdownMenuEle && dropdownItemEle) {
                if (_.isArray(value)) {
                    value = value[0];
                }
                const index = _.findIndex(options, option => option.code === (value as IProjectAttribute)?.code);
                if (-1 === index) {
                    return;
                }
                dropdownMenuEle.scrollTo({
                    top: dropdownItemEle.clientHeight * index,
                    left: 0,
                    behavior: 'smooth'
                });
            }
        }, 200);

        // 按上下箭头切换 item 时，超出 menu 屏的 item，滚动到屏内
        $(sanComponent).on('keydown', (event) => {
            if (!('ArrowUp' === event.key || 'ArrowDown' === event.key)) {
                return;
            }
            setTimeout(() => {
                const dropdownMenuEle = $(sanComponent).find('.santd-select-dropdown-menu')[0];
                const $dropdownItemActive = $(sanComponent).find('.santd-select-dropdown-menu-item-active');
                const dropdownItemActiveEle = $dropdownItemActive[0];
                if (dropdownMenuEle && dropdownItemActiveEle) {
                    const index = $dropdownItemActive.index();
                    if (-1 === index) {
                        return;
                    }
                    dropdownMenuEle.scrollTo({
                        top: dropdownItemActiveEle.clientHeight * (index + 1) - dropdownMenuEle.clientHeight,
                        left: 0,
                        behavior: 'smooth'
                    });
                }
            }, 200);
        })
    }
};
